export default "__VITE_ASSET__YswClE4w__"